import {ChangeDetectionStrategy, Component, HostBinding} from '@angular/core'

@Component({
  selector: 'cft-teaser-card-plot, *[cft-teaser-card-plot]',
  templateUrl: 'teaser-card-plot.component.html',
  styles: `
    @reference '../../../../../styles/app-reference.css';

    :host {
      @apply block;
      @apply font-medium text-vermillon-700;
      @apply mb-2xs;
    }
  `,

  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
})
export class TeaserCardPlotComponent {
  @HostBinding('class')
  className = 'plot-sm '
}
